'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Decimal = function (_PureComponent) {
  (0, _inherits3.default)(Decimal, _PureComponent);
  function Decimal() {
    (0, _classCallCheck3.default)(this, Decimal);
    return (0, _possibleConstructorReturn3.default)(this, (Decimal.__proto__ || (0, _getPrototypeOf2.default)(Decimal)).apply(this, arguments));
  }
  (0, _createClass3.default)(Decimal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M7.977 17.293c.388.616.582 1.38.582 2.294 0 1.522-.408 2.63-1.222 3.32s-2.11 1.04-3.892 1.04c-1.354 0-2.503-.198-3.446-.593v-2.168a7.512 7.512 0 0 0 2.99.616c.99 0 1.697-.186 2.123-.56s.64-.977.64-1.814c0-.852-.24-1.472-.72-1.86s-1.236-.582-2.27-.582h-.754V15h.752c.99 0 1.712-.186 2.168-.56s.685-1.007.685-1.905c0-.822-.194-1.42-.582-1.792s-1.023-.56-1.906-.56A7.808 7.808 0 0 0 0 10.847V8.678c1.004-.41 2.206-.616 3.606-.616 1.628 0 2.834.33 3.618.993S8.4 10.8 8.4 12.307c0 .913-.18 1.68-.537 2.305S6.96 15.685 6.23 15.96c.777.273 1.36.718 1.747 1.334zm2.317 6.23c-.26-.265-.388-.688-.388-1.266 0-.593.13-1.02.388-1.278s.677-.39 1.255-.39c.592 0 1.022.13 1.29.39s.398.684.398 1.277c0 .578-.137 1-.41 1.267s-.7.4-1.28.4c-.577 0-.996-.134-1.254-.4zm11.8-15.19v1.873l-4.702 13.466h-2.74l4.75-13.147h-5.73v-2.19h8.422zm8.833 7.213c.715.746 1.073 1.948 1.073 3.606 0 1.69-.41 2.91-1.233 3.663s-2.168 1.13-4.04 1.13c-1.172 0-2.26-.19-3.264-.57v-2.192a7.626 7.626 0 0 0 3.036.616c.942 0 1.627-.214 2.053-.64s.64-1.118.64-2.077c0-.943-.225-1.617-.674-2.02s-1.184-.605-2.204-.605c-.883 0-1.727.053-2.534.16V8.333h8.034L30.47 10.41h-4.2v4.063c.547-.03.95-.046 1.21-.046 1.58 0 2.73.373 3.446 1.118z'
      }));
    }
  }]);
  return Decimal;
}(_react.PureComponent);
Decimal.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Decimal;